var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptBillCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Receipt bill check - Iconly Pro"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7018 14.9267L13.2717 15.1996C13.8708 15.4864 14.564 15.0493 14.5633 14.3845L14.556 5.19369C14.556 3.37669 13.5453 2.25 11.7313 2.25H6.25689C4.43843 2.25 3.44966 3.37669 3.44966 5.19369L3.43652 14.3831C3.4358 15.0479 4.12903 15.4856 4.72886 15.1982L5.29439 14.9274C5.63444 14.764 6.02776 14.7523 6.3773 14.8953L7.98705 15.5513C8.6358 15.8162 9.3633 15.8162 10.0121 15.5513L11.6189 14.8953C11.9684 14.7523 12.3617 14.764 12.7018 14.9267Z",
    stroke: "#3F906D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.94238 10.8398H10.7734",
    stroke: "#3F906D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.25 7.37906L8.40664 8.53567L10.7738 6.16846",
    stroke: "#3F906D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptBillCheck);
export default __webpack_public_path__ + "static/media/receipt_bill_check.fd09a1fcecea7acfb5f74bc1d139a68a.svg";
export { ForwardRef as ReactComponent };